import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const LocalUploadFile = resolve => {
  import("pages/app/uploadFile/uploadFile.vue").then(module => {
    resolve(module);
  });
};

const UploadAd = resolve => {
  import("pages/app/uploadAd/uploadAd.vue").then(module => {
    resolve(module);
  });
};

const BatchUploadFile = resolve => {
  import("pages/app/batchUploadFile/batchUploadFile.vue").then(module => {
    resolve(module);
  });
};

const GuideToB = resolve => {
  import("pages/app/guide/guideToB.vue").then(module => {
    resolve(module);
  });
};

const RecordToB = resolve => {
  import("pages/app/guide/recordToB.vue").then(module => {
    resolve(module);
  });
};

const InstallToB = resolve => {
  import("pages/app/guide/installToB.vue").then(module => {
    resolve(module);
  });
};

const InstallToC = resolve => {
  import("pages/app/guide/installToC.vue").then(module => {
    resolve(module);
  });
};

const GuideToC = resolve => {
  import("pages/app/guide/guideToC.vue").then(module => {
    resolve(module);
  });
};

const GuideTraceless = resolve => {
  import("pages/app/guide/traceless.vue").then(module => {
    resolve(module);
  });
};

const Install = resolve => {
  import("pages/app/guide/install.vue").then(module => {
    resolve(module);
  });
};

const SecureGuide = resolve => {
  import("pages/app/guide/secureGuide.vue").then(module => {
    resolve(module);
  });
};

const Follow = resolve => {
  import("pages/app/follow/follow.vue").then(module => {
    resolve(module);
  });
};

const Layout = resolve => {
  import("pages/web/layout/layout.vue").then(module => {
    resolve(module);
  });
};

const Index = resolve => {
  import("pages/web/index/index.vue").then(module => {
    resolve(module);
  });
};

const Device = resolve => {
  import("pages/web/device/device.vue").then(module => {
    resolve(module);
  });
};

const Record = resolve => {
  import("pages/web/record/record.vue").then(module => {
    resolve(module);
  });
};

const KyCode = resolve => {
  import("pages/app/kyCode/kyCode.vue").then(module => {
    resolve(module);
  });
};

const Share = resolve => {
  import("pages/web/share/share.vue").then(module => {
    resolve(module);
  });
};

const MyShare = resolve => {
  import("pages/web/myShare/myShare.vue").then(module => {
    resolve(module);
  });
};

const ClientPay = resolve => {
  import("pages/web/clientPay/clientPay.vue").then(module => {
    resolve(module);
  });
};

const AliPayResult = resolve => {
  import("pages/web/aliPayResult/aliPayResult.vue").then(module => {
    resolve(module);
  });
};

Vue.use(Router);
export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: Layout,
      meta: {
        auth: true,
        name: "智慧打印"
      },
      name: "Layout",
      children: [
        {
          path: "/",
          component: Index,
          meta: {
            auth: true,
            name: "自助打印"
          },
          name: "index"
        },
        {
          path: "/device",
          component: Device,
          meta: {
            name: "设备管理"
          },
          name: "device"
        },
        {
          path: "/record",
          component: Record,
          meta: {
            name: "打印记录"
          },
          name: "record"
        },
        {
          path: "/myShare",
          component: MyShare,
          meta: {
            name: "我的分享"
          },
          name: "myShare"
        }
      ]
    },
    {
      path: "/localUploadFile",
      component: LocalUploadFile,
      meta: {
        auth: true
      },
      name: "LocalUploadFile"
    },
    {
      path: "/BatchUploadFile",
      component: BatchUploadFile,
      meta: {
        auth: true
      },
      name: "BatchUploadFile"
    },
    {
      path: "/uploadAd",
      component: UploadAd,
      meta: {
        auth: true
      },
      name: "UploadAd"
    },
    {
      path: "/clientPay",
      component: ClientPay,
      meta: {
        auth: true
      },
      name: "clientPay"
    },
    {
      path: "/success",
      component: AliPayResult,
      meta: {
        auth: true
      },
      name: "aliPayResult"
    },
    {
      path: "/kyCode",
      component: KyCode,
      meta: {
        auth: true
      },
      name: "kyCode"
    },
    {
      path: "/share",
      component: Share,
      name: "share",
      meta: {
        auth: true
      }
    },
    {
      path: "/guideToB",
      component: GuideToB,
      meta: {
        auth: true
      },
      name: "guideToB"
    },
    {
      path: "/recordToB",
      component: RecordToB,
      meta: {
        auth: true
      },
      name: "recordToB"
    },
    {
      path: "/installToB",
      component: InstallToB,
      meta: {
        auth: true
      },
      name: "installToB"
    },
    {
      path: "/installToC",
      component: InstallToC,
      meta: {
        auth: true
      },
      name: "installToC"
    },
    {
      path: "/guideToC",
      component: GuideToC,
      meta: {
        auth: true
      },
      name: "guideToC"
    },
    {
      path: "/guideTraceless",
      component: GuideTraceless,
      meta: {
        auth: true
      },
      name: "guideTraceless"
    },
    {
      path: "/install",
      component: Install,
      meta: {
        auth: true
      },
      name: "install"
    },
    {
      path: "/secureGuide",
      component: SecureGuide,
      meta: {
        auth: true
      },
      name: "secureGuide"
    },
    {
      path: "/follow",
      component: Follow,
      meta: {
        auth: true
      },
      name: "follow"
    }
  ]
});
